<template>
  <div class="container-fluid __windowHeight_">
      <div class="forgotpassword_page __100vh_ d-flex justify-content-center align-items-center">
        <div class="__maincontent">
            <div class="__title">
                <b>Forgot Your Password</b>
            </div>
            <p class="mb-1">Please Enter the Same Email Address That You Used for Login to Andalin Account. </p>
            <form @submit.prevent="handleSubmit">
                <b-form-input
                  v-model="form.userEmail"
                  v-validate="'required|email'"
                  class="__forminput"
                  name="email"
                  type="email"
                  required
                  placeholder="Enter Your Email Address Here"/>
                <div class="__errorMsg">{{ errorMessage.message}}</div>
                <button class="button__bluesmall py-2 mt-4"
                    type="submit">
                    <b-spinner v-if="search" small variant="light" label="Spinning" />
                    <span v-else>Submit</span>
                </button>
            </form>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      form: {
        userEmail: ''
      },
      search: false,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/items',
      checkEmail: 'auth/checkEmail',
      error: 'auth/errorCheckEmail',
      isLoading: 'auth/isLoading'
    })
  },
  methods: {
    forgotpassword: function () {
      this.$eventHub.$emit('dialog-forgot-password')
    },
    handleSubmit (e) {
      this.errorMessage = ''
      this.$validator.validateAll().then((result) => {
        if (result) {
          const payload = {
            userEmail: this.form.userEmail
          }
          this.$store.dispatch('auth/POST_PASS_MAIL', payload)
          this.search = true
          setTimeout(() => {
            this.search = false
            this.errorMessage = this.error ? this.errorMessage = this.error : this.errorMessage = ''
            if (this.checkEmail.message) { return this.forgotpassword() }
          }, 1000)
          return
        }

        alert('Correct them errors!')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/forgotPassword/index.vue